import render from './render'

export default {
  name: 'Source',

  props: {
    value: {
      type: Object,
      default: undefined
    }
  },

  render
}
